module.exports = __webpack_public_path__ + "static/media/profile-duane-johnson.45295389.jpg";